export default "__VITE_ASSET__CVtkEN7r__"